<template>
  <el-dialog
    v-if="visible"
    visible
    show-close
    width="800px"
    :title="$l('dialog_title_fileProcessMessage') || '处理结果明细'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
  >
    <Main ref="main" :data="data" />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_close') || '关闭' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: () => false },
    data: { type: Array, default: () => [] },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
